import type { Translations } from '../../types'

const crumbsMessages: Translations = {
  "crumbs.settings": "Impostazioni",
  "crumbs.profile": "Account",
  "crumbs.userDetail": "Dettaglio utente"
}

export default crumbsMessages
